"use client";
import { jsx as C } from "react/jsx-runtime";
import { memo as n, forwardRef as i } from "react";
import { useSvgIcon as m } from "../useSvgIcon.js";
const s = n(
  i((o, r) => {
    const { monochrome: c, ...t } = o, e = m({
      ...t,
      ref: r
    });
    return /* @__PURE__ */ C(
      "svg",
      {
        width: 24,
        height: 24,
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...e(),
        children: /* @__PURE__ */ C(
          "path",
          {
            d: "M29.9995 16.1939C29.9369 14.4484 28.5154 13.0854 26.8173 13.1446C26.0647 13.1716 25.349 13.4895 24.8057 14.0227C22.4125 12.3417 19.6012 11.4203 16.7114 11.3558L18.075 4.59437L22.5742 5.56971C22.6994 6.76035 23.7341 7.6225 24.8889 7.49294C26.0437 7.36386 26.8799 6.297 26.7542 5.10636C26.6286 3.91572 25.5943 3.05357 24.4395 3.18313C23.7757 3.25297 23.1801 3.65178 22.8512 4.24469L17.699 3.18313C17.3491 3.10221 16.9987 3.32859 16.9202 3.69513C16.9202 3.70042 16.9202 3.70042 16.9202 3.70572L15.3684 11.2267C12.4421 11.2753 9.5944 12.202 7.16989 13.8936C5.93662 12.6976 3.99281 12.7569 2.83287 14.0337C1.67294 15.3053 1.7304 17.3095 2.96881 18.5054C3.2094 18.7371 3.48595 18.9365 3.79427 19.0766C3.77325 19.3945 3.77325 19.7124 3.79427 20.0303C3.79427 24.8844 9.28094 28.8334 16.0476 28.8334C22.8143 28.8334 28.301 24.8897 28.301 20.0303C28.322 19.7124 28.322 19.3945 28.301 19.0766C29.3567 18.5324 30.0205 17.4116 29.9995 16.1939ZM8.97776 18.3652C8.97776 17.1693 9.92374 16.1939 11.0837 16.1939C12.2436 16.1939 13.1896 17.1693 13.1896 18.3652C13.1896 19.5612 12.2436 20.5365 11.0837 20.5365C9.9186 20.5254 8.97776 19.5612 8.97776 18.3652ZM21.1895 24.4099V24.3237C19.6951 25.4821 17.8662 26.0745 15.9953 25.9941C14.1244 26.075 12.2959 25.4821 10.8011 24.3237C10.6025 24.0757 10.6389 23.7043 10.8795 23.4996C11.0883 23.3219 11.3864 23.3219 11.6008 23.4996C12.8654 24.4533 14.407 24.9383 15.9743 24.8627C17.542 24.9489 19.0888 24.4856 20.3687 23.543C20.5986 23.3113 20.9746 23.3166 21.1998 23.5536C21.4245 23.7905 21.4194 24.1783 21.1895 24.4099ZM20.9022 20.6926C20.8658 20.6926 20.8345 20.6926 20.7976 20.6926L20.8135 20.6116C19.6535 20.6116 18.7076 19.6363 18.7076 18.4404C18.7076 17.2444 19.6535 16.2691 20.8135 16.2691C21.9734 16.2691 22.9194 17.2444 22.9194 18.4404C22.9661 19.6368 22.0622 20.6439 20.9022 20.6926Z",
            fill: "var(--icon-color)"
          }
        )
      }
    );
  })
);
s.displayName = "IconReddit";
export {
  s as IconReddit
};
